<template>
  <b-container>
    <b-embed
      v-if="hasPermission"
      :src="dashboardUrl"
      type="iframe"
      aspect="16by9"
      allowfullscreen
    />
    <div v-else>
      <noPermission
        v-if="hasPermission !== null"
        style="margin-top: 0 !important;"
      />
    </div>
  </b-container>
</template>

<script>
import {
  BContainer,
  BEmbed,
} from 'bootstrap-vue'


import NoPermission from '@/views/error/NoPermission.vue'

import MerchantService from '@/service/merchant'

const jwt = require('jsonwebtoken')

export default {
  components: {
    BContainer,
    BEmbed,
    NoPermission,
  },
  data() {
    return {
      dashboardUrl: null,
      hasPermission: null,
    }
  },
  async mounted() {
    const { groupName: merchant, groupId } = await this.getMerchantname()

    this.hasPermission = groupId !== 1

    const METABASE_SITE_URL = metaUrl()
    const METABASE_SECRET_KEY = accessKey()

    const payload = {
      resource: { dashboard: 263 },
      params: {
        grupo: merchant,
      },
      exp: Math.round(Date.now() / 1000) + (10 * 60),
    }

    const token = await jwt.sign(payload, METABASE_SECRET_KEY)
    this.dashboardUrl = `${METABASE_SITE_URL}embed/dashboard/${token}#bordered=true&titled=true`
  },
  methods: {
    async getMerchantname() {
      const { group_name: groupName, group_id: groupId } = await new MerchantService().getChildren()
      return {
        groupName, groupId,
      }
    },
  },
}
</script>
